import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCanadianDatTips = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.4286 1L10.7979 4.06013C10.6403 4.35281 10.2922 4.47423 9.99351 4.34033L8.61292 3.73502L9.37752 8.77916C9.41835 9.05467 9.09765 9.22273 8.90283 9.02955L6.74317 6.86614L6.41341 7.86376C6.29094 8.23107 5.91287 8.44323 5.54735 8.34953L3.39137 7.7928L4.00737 10.879C4.07786 11.233 3.89535 11.5895 3.57253 11.7272L3 11.9664L7.22148 15.8149C7.52577 16.0942 7.65844 16.5189 7.56935 16.9283L7.32297 18.0754L11.3198 17.5336C11.7186 17.48 12.0719 17.8061 12.0626 18.2174L11.9612 23H12.4286H12.896L12.7946 18.2174C12.7872 17.8042 13.1404 17.4781 13.5374 17.5336L17.5306 18.0754L17.2842 16.9283C17.1988 16.5208 17.335 16.0942 17.6393 15.8149L21.8571 11.9664L20.7302 11.4881L21.4658 7.78904L18.6647 8.51391L18.1176 6.86614L15.958 9.02955C15.765 9.22464 15.4425 9.05467 15.4832 8.77916L16.2478 3.73502L14.8672 4.34033C14.5667 4.47232 14.2186 4.35281 14.0628 4.06013L12.4286 1Z",
		stroke: "#8A94A6",
		strokeWidth: 1.6,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgCanadianDatTips);
export { ForwardRef as ReactComponent };
